<template lang="html">
    <div>

        <!-- Header -->
        <div class="lightest larger bold d-flex p-2 pointer" :class="refundColor(refund)" @click="expandRefundClick()">
            <div class="flex-grow-1">{{refundStatus(refund)}} {{refundChannel(refund)}} {{refundValue(refund)}}</div>
            <div>
                <span>{{refund.code}}</span>
                <span class="ml-2">
                    <i v-if="isExpanded == true" class="fas fa-chevron-up"></i>
                    <i v-else class="fas fa-chevron-down"></i>
                </span>
            </div>
        </div>

        <!-- Content -->
        <div v-if="isExpanded == true" class="bg-faded border-light p-2">

            <div class="d-flex">
                <!-- Channel -->
                <div class="w-100"><span class="bold">Sales Channel:</span> {{refundChannel(refund)}}</div>
                <!-- Is Request -->
                <div class="w-100"><span class="bold">Is Request:</span> {{refundIsRequest(refund)}}</div>
            </div>

            <div class="d-flex">
                <!-- Payment Method -->
                <div class="w-100"><span class="bold">Payment Method:</span> {{refundPaymentType(refund)}}</div>
                <!-- Type -->
                <div class="w-100"><span class="bold">Type:</span> {{refundType(refund)}}</div>
            </div>

            <div class="d-flex">
                <!-- Reason -->
                <div class="w-100"><span class="bold">Reason:</span> {{refundReason(refund)}}</div>
                <!-- Value -->
                <div v-if="refundValue(refund)" class="w-100"><span class="bold">Value:</span> {{refundValue(refund)}}</div>
            </div>

            <!-- Refund Items -->
            <div v-if="refund.refundItems.length > 0" class="w-100">
                <span class="bold">Refund items:</span>
                <div>
                    <div v-for="refundItem in refund.refundDetailsItems">
                        <div>{{refundItemQtd(refundItem)}}x {{refundItemName(refundItem)}}</div>
                    </div>
                </div>
            </div>

            <div class="d-flex justify-content-between my-2">
                <button v-if="shwowCancelBtn" class="btn action " @click="cancelRefunded(refund)">Cancel this refund</button>
                <button v-if="showExecuteBtn" class="btn blue btnMarkAsRefunded" @click="markAsRefunded(refund)">Mark as refunded</button>
            </div>
        </div>

    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
export default {
    created: function () {
        // Set refund as expanded if the link contains the same id, example: localhost:8081/reservations/view/27656?refundId=3#refunds
        if(this.$route.query.refundId && this.$route.query.refundId == this.refund.id){
            this.isExpanded = true
        }
    },
    props: {
        refund: {
            tipe: Object,
            default: null,
            required: true
        }
    },
    data: function () {
        return {
            isExpanded: false,
        }
    },
    computed: {
        ...mapGetters([
            'getRefundReasons',
            'getPercentageOrCurrency',
            'getPaymentTypeListAll',
            'getRefundStatus'
        ]),
        shwowCancelBtn: function () {
            return this.refund.status != -100
        },
        showExecuteBtn: function () {
            return this.refund.isRequest == true && this.refund.isProcessed == false
        },
    },
    methods: {
        ...mapActions([
            'openModal',
            'executeRefund',
            'selectRefund',
        ]),
        expandRefundClick: function () {
            this.isExpanded = !this.isExpanded
        },
        refundStatus: function (refund) {
            let foundStatus =this.getRefundStatus.find(status => status.id == refund.status)

            return foundStatus? foundStatus.label : ''
        },
        refundChannel: function (refund) {
            return refund.refundChannels[0].brandName
        },
        refundPaymentType: function (refund) {
            let foundPyamentMethod =  this.getPaymentTypeListAll.find(pm => pm.id == refund.paymentType)
            return foundPyamentMethod? foundPyamentMethod.description : ' - '
        },
        refundType: function (refund) {
            if(refund.refundItems.length > 0){
                return 'Reduce Quantity'
            } else if(refund.isToRefundTotal == true){
                return 'Total'
            } else {
                let output = refund.amountType == 0? 'Value' : 'Percentage'
                let value = (refund.amount ) + (refund.amountType == 0? '€' : '%')
                return output + ` (${value})`
            }
        },
        refundColor: function (refund) {
            let foundStatus =this.getRefundStatus.find(status => status.id == refund.status)

            return foundStatus? 'bg-'+foundStatus.color : ''
        },
        refundIsRequest: function (refund) {
            return refund.isRequest? 'Yes' : 'No'
        },
        refundReason: function (refund) {
            let reasonId = refund.refundReasonType
            if(reasonId == 0){
                return refund.reason != null ? 'Other: ' + refund.reason : ' - no reason provided -'
            } else {
                let foundReason = this.getRefundReasons.find(r => r.id == reasonId)
                return foundReason? foundReason.text : '-'
            }
        },
        refundValue: function (refund) {
            if(!refund.amountResumeValue){
                return null
            }
            return this.formatPrice(refund.amountResumeValue) + '€'
        },
        refundItemName: function (refundItem) {
            if(refundItem.bookingGenderPrice){
                return refundItem.bookingGenderPrice.audienceTypeDescription
            } else if(refundItem.bookingComponent){
                return refundItem.bookingComponent.componentName + ' - ' + refundItem.bookingComponent.componentPriceName
            }
        },
        refundItemQtd: function (refundItem) {
            return refundItem.quantity
        },
        markAsRefunded: function (refund) {
            this.$dialog.confirm('<h1>Mark as refunded</h1><p class="mt-3">Are your sure you whant to mark as refunded?<br><b>This cannot be undone!</b></p>').then(() => {
                this.executeRefund()
            }).catch(function () {
                // This will be triggered when user clicks on cancel
            });
        },
        cancelRefunded: function (refund) {
            this.selectRefund(refund).then(r => {
                this.openModal('RefundCancel')

            })
            console.log(refund);
        }
    }
}
</script>

<style lang="scss" scoped>
@keyframes blink {
    0% {
        opacity: 0;
    }
    33% {
        opacity: 1;
    }
    66% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}

.btnMarkAsRefunded{
        animation: 1s ease-out 0s 1 blink;
}
</style>



// WEBPACK FOOTER //
// refundSingleRow.vue?6158c90b